import { UsersPage } from './UsersPage'

export function UsersCnt() {
  return <UsersPage />
}
